var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-header",style:({ zIndex: _vm.zIndex })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"task-ids"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }